'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.factory("autosizingService", function () {
  var delegatesMap = {};
  var containerTypes = {};
  var defaultContainerType = null;
  return {
    registerDelegate: function registerDelegate(directiveName, provider) {
      delegatesMap[directiveName] = provider;
    },
    getDelegate: function getDelegate($element) {
      for (var directiveName in delegatesMap) {
        var directiveController = $element.controller(directiveName);
        if ($element.controller(directiveName)) {
          var delegateClass = delegatesMap[directiveName];
          return new delegateClass(directiveController, $element);
        }
      }
      return null;
    },
    ////

    registerContainerType: function registerContainerType(attribute, containerStrategy, isDefault) {
      containerTypes[attribute] = containerStrategy;
      if (isDefault) {
        defaultContainerType = attribute;
      }
    },
    getContainerStrategy: function getContainerStrategy(containerCtrl, $element, $attrs) {
      var containerStrategy = null;
      for (var containerType in containerTypes) {
        if (_.has($attrs, containerType)) {
          containerStrategy = containerTypes[containerType];
        }
      }
      if (containerStrategy == null) {
        containerStrategy = containerTypes[defaultContainerType];
      }
      return new containerStrategy(containerCtrl, $element);
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/ui/autosizing/asRegistry.js
// module id = 2915
// module chunks = 13